export default __webpack_public_path__ + "static/media/stcvitlogo.52b511ce.png";